import { debug, observer, pr, React, ui } from "aaa";
import { ContactsStore, phoneNumberToString } from "stores/ContactsStore";
import { IPostContactResponse } from "types/contact";
import { ISigningResponse } from "types/signing";
import { SigningComponent } from "../signing/views/SigningComponent";


type IProps = {
    contactsStore: ContactsStore;
    contactResponse: IPostContactResponse;
    onClose: () => void;
    onRetry: () => void;
    onSuccess: () => void;
};

@observer
export class NewAddressSigning extends React.Component<IProps, {}> {
    render() {
        return (
            <SigningComponent
                signingInfo={this.props.contactResponse.signInfo}
                content={
                    <div>
                        <pr.SigningLabelContainer>
                            <pr.SigningLabelSet>
                                <pr.SigningLabelTitle>{ui.__("address.signing.title")}</pr.SigningLabelTitle>
                                <pr.SigningLabel>{phoneNumberToString(this.props.contactResponse.contact)}</pr.SigningLabel>
                            </pr.SigningLabelSet>
                        </pr.SigningLabelContainer>
                    </div>
                }

                onSuccess={async (response: ISigningResponse) => {
                    debug.log("### Signing success", response);
                    this.props.onSuccess();
                }}
                onRetry={this.props.onRetry}
                onClose={this.props.onClose}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/common/NewAddressSigning.tsx